import { Component, h } from '@stencil/core';
import trackEvent from '../../utils/analytics';

@Component({
  tag: 'ci-fundraising',
  styleUrl: 'ci-fundraising.scss',
})
export class ciFundraising {
  render() {
    return (
      <div class="ciFundraising">
        <div class="ciFundraising-text">
          <h1 class="ciFundraising-heading">T-shirt Fundraisers</h1>
          <span class="ciFundraising-subHeading">Raise money and awareness for anything you care about.</span>
          <br />
          <br />
          <div class="ciFundraising-buttons">
            <ci-button variant="primary" href={`${process.env.CI_HOSTNAME}/fundraising`} onClick={() => trackEvent('fundraising', 'How it Works')}>
              How it Works
            </ci-button>
            <ci-button variant="secondary" href={`${process.env.CI_HOSTNAME}/fundraising/catalog?ref=CI_MM_`} onClick={() => trackEvent('fundraising', 'Start a Fundraiser')}>
              Start a Fundraiser
            </ci-button>
          </div>
        </div>
        <div class="ciFundraising-image"></div>
      </div>
    );
  }
}
